import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Home.html?raw';



class Home extends compose(_WidgetBaseSP) {
	templateString: any = template;


	postCreate(): void {
		super.postCreate.apply(this, arguments as any);


	}


	startup(): void {
		super.startup.apply(this, arguments as any);

	}
}

export default mdsWidget(Home);